import PropTypes from 'prop-types';
import { ListItemText, Stack, Typography } from '@mui/material';

import { componentsSize, LABEL_TYPES, STATUS_TYPES } from 'constants/components';
import { Label, Status, TitleTooltip } from 'components/simple';

const styles = {
  listItemPrimaryText: ({ breakpoints }, labelType, isDisabledClick) => ({
    maxWidth: labelType ? '100%' : '90%',
    minHeight: 40,
    maxHeight: 80,
    wordBreak: 'break-word',
    cursor: isDisabledClick ? 'default' : 'pointer',
    [breakpoints.down('md')]: {
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
    },
    [breakpoints.up('md')]: {
      maxHeight: 56,
    },
  }),
};

export const ListItemContent = ({
  labelType = null,
  statusType,
  showTopStatus,
  itemCaption = null,
  itemName,
  isDisabledClick = false,
  nameLength = 0,
}) => (
  <Stack
    flex={1}
    spacing={2}
    direction={{ xs: 'column', md: 'row' }}
    justifyContent={{ xs: 'flex-start', md: 'space-between' }}
    alignItems={{ xs: 'flex-start', md: 'center' }}
  >
    <Stack spacing={2} width="100%">
      {labelType &&
        (showTopStatus ? (
          <Stack direction="row" spacing={2}>
            <Label labelType={labelType} />

            <Status statusType={statusType} size={componentsSize.medium} />
          </Stack>
        ) : (
          <Label labelType={labelType} />
        ))}

      <ListItemText
        disableTypography
        primary={
          <TitleTooltip
            titleLength={nameLength}
            title={itemName}
            variant="h2"
            component="p"
            sx={(theme) => styles.listItemPrimaryText(theme, labelType, isDisabledClick)}
          />
        }
        secondary={
          itemCaption && (
            <Typography variant="caption" component="p" mt={2}>
              {itemCaption}
            </Typography>
          )
        }
      />
    </Stack>

    {!showTopStatus && <Status statusType={statusType} size={componentsSize.large} />}
  </Stack>
);

ListItemContent.propTypes = {
  statusType: PropTypes.oneOf(Object.values(STATUS_TYPES)).isRequired,
  labelType: PropTypes.oneOf(Object.values(LABEL_TYPES)),
  showTopStatus: PropTypes.bool.isRequired,
  itemName: PropTypes.string.isRequired,
  itemCaption: PropTypes.string,
  isDisabledClick: PropTypes.bool,
  nameLength: PropTypes.number,
};
